/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SettingsService {
    /**
     * Get application settings
     * Retrieve current application settings
     * @returns any Settings retrieved successfully
     * @throws ApiError
     */
    public static getSettings(): CancelablePromise<{
        /**
         * Enable autocomplete in query editor
         */
        autoComplete?: boolean;
        /**
         * Date format pattern
         */
        dateFormat?: string;
        /**
         * Font family for code editor
         */
        fontFamily?: string;
        /**
         * Font size for code editor
         */
        fontSize?: number;
        /**
         * Application language
         */
        language?: string;
        /**
         * Default query result limit
         */
        queryLimit?: number;
        /**
         * Show line numbers in code editor
         */
        showLineNumbers?: boolean;
        /**
         * Enable syntax highlighting
         */
        syntaxHighlighting?: boolean;
        /**
         * Application theme
         */
        theme?: 'light' | 'dark' | 'auto';
        /**
         * Time format pattern
         */
        timeFormat?: string;
        /**
         * Timezone setting
         */
        timezone?: string;
        /**
         * Keep explorer expanded state between sessions
         */
        keepExplorerExpandedState?: boolean;
        /**
         * Enable compact view for database explorer
         */
        explorerCompactView?: boolean;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/settings',
        });
    }
    /**
     * Update application settings
     * Update application settings
     * @returns any Settings updated successfully
     * @throws ApiError
     */
    public static updateSettings({
        requestBody,
    }: {
        requestBody: {
            /**
             * Enable autocomplete in query editor
             */
            autoComplete?: boolean;
            /**
             * Date format pattern
             */
            dateFormat?: string;
            /**
             * Font family for code editor
             */
            fontFamily?: string;
            /**
             * Font size for code editor
             */
            fontSize?: number;
            /**
             * Application language
             */
            language?: string;
            /**
             * Default query result limit
             */
            queryLimit?: number;
            /**
             * Show line numbers in code editor
             */
            showLineNumbers?: boolean;
            /**
             * Enable syntax highlighting
             */
            syntaxHighlighting?: boolean;
            /**
             * Application theme
             */
            theme?: 'light' | 'dark' | 'auto';
            /**
             * Time format pattern
             */
            timeFormat?: string;
            /**
             * Timezone setting
             */
            timezone?: string;
            /**
             * Keep explorer expanded state between sessions
             */
            keepExplorerExpandedState?: boolean;
            /**
             * Enable compact view for database explorer
             */
            explorerCompactView?: boolean;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
